import { api } from "@/services/api"
import { queryClient } from "@/queryClient"

export type CreatePaymentRequestRequest = {
  customer: {
    name: string
    email: string | null
    phone: string | null
  }
  description: string
  vatCode: "T0" | "T1" | "T2" | "T5"
  amountNet: number
}

export const createPaymentRequest = async (
  params: CreatePaymentRequestRequest
) => {
  await api.post("/beepaidgo/payment-requests/", {
    body: params,
  })

  queryClient.invalidateQueries([
    PAYMENT_REQUESTS_QUERY_KEY,
  ])
  queryClient.invalidateQueries([CUSTOMERS_QUERY_KEY])
}
